import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown } from '_components';
import styles from './FunctionalDeficits.module.css'
import { GoalDropDown } from '../Goals';

class PatientCareCenterNoteSubjectiveFunctionalDeficitEntry extends React.Component {

    removeFuncDef() {
        this.props.removeChildRow(this.props.noteId, 'PTGOALS', 'GO', this.props.funcDefEntry.GONO);
    }

    render() {
        return (
            <div>
                <div className={styles.textfield_row}>
                    <span className={styles.add_button} />
                    <span className={styles.column_1}>
                        <GoalDropDown
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            isFunctional={true}
                            includeCustom={false}
                            className={styles.goal_dropdown}
                        />
                    </span>
                    <span className={styles.column_2}>
                        <DBDropDown
                            className={styles.goal_dropdown}
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GOPLOF'
                            customOptions={this.props.goalLevels}
                        />
                    </span>
                    <span className={styles.column_3}>
                        <DBDropDown
                            className={styles.goal_dropdown}
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GOCLOF'
                            customOptions={this.props.clofGoalLevels}
                        />
                    </span>
                    <span className={styles.column_4}>
                        <DBDropDown
                            className={styles.goal_dropdown}
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            field='GOGOALLEVEL'
                            customOptions={this.props.goalLevels}
                        />
                    </span>
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.removeFuncDef()} />
                    </div>
                </div>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let activityName = goal.GOMGNO &&
        goal.GOMGNO !== parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE)
        ? state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : goal.GOCUSTOM ? goal.GOCUSTOM : '';
    // get based on XREF
    let glnos = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
        .filter(key => {
            return (state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO);
        })
        .map(key => state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO);

    let clofGoalLevels = Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
        .filter(key => {
            return (glnos.includes(state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO));
        })
        .sort((a, b) => {
            let aKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                .find(key => {
                    return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                        state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[a].GLNO
                });
            let aOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[aKey].GLXORDER;

            let bKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                .find(key => {
                    return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                        state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[b].GLNO
                });
            let bOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[bKey].GLXORDER;

            return aOrder - bOrder;
        })
        .map(key => {
            return {
                id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
            }
        });
        let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
        let isPeds = state.entities.admissions[epno].isPeds;
        let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
        let goalLevels;
        if(isPeds && isPedsEnabled){
            goalLevels = Object.keys(clofGoalLevels)
            .map(key => {
                return clofGoalLevels[key];
            });
        }else{
            goalLevels = Object.keys(clofGoalLevels)
            .filter(key => {
                return clofGoalLevels[key].clofOnly === false;
            })
            .map(key => {
                return clofGoalLevels[key];
            });
        }

    return {
        noteId,
        funcDefEntry: state.entities.notes.PTGOALS[ownprops.id],
        goal,
        activityName,
        clofGoalLevels,
        goalLevels,
    };
}

const connectedPatientCareCenterNoteSubjectiveFunctionalDeficitEntry = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveFunctionalDeficitEntry);
export { connectedPatientCareCenterNoteSubjectiveFunctionalDeficitEntry as PatientCareCenterNoteSubjectiveFunctionalDeficitEntry };


